import React from "react";
import "../../assets/css/ninja-slider.css"
import "../../assets/css/thumbnail-slider.css"
import $ from "jquery"
import Panzoom from '@panzoom/panzoom'
import { saveAs } from 'file-saver'

import axios from "axios";
export default class GallerySlider extends React.Component {

    constructor(props) {
        super(props)

        this.script1 = null
        this.script2 = null
        this.myRef = React.createRef();
       
        this.currentImg = null
    }

    componentDidUpdate() {

    }

    componentDidMount() {

        this.script1 = document.createElement("script");
        this.script1.src = "./gallery/ninja-slider.js";
        this.script1.type = 'text/javascript';
        this.script1.async = true;
        this.script1.id = 'ninja-slider';

        document.body.appendChild( this.script1);

        this.script2 = document.createElement("script");
        this.script2.src = "./gallery/thumbnail-slider.js";
        this.script2.type = 'text/javascript';
        this.script2.async = true;
        this.script2.id = 'thumbnail-slider';

        document.body.appendChild(this.script2);

        if(this.props.info.navigation_ref === "explore_the_trends"){

            this.props.imagesarr.map((val,index) => {
                const element = document.getElementById('img'+index)
                const panzoom = Panzoom(element, {
    
                    // options here
                    step:3,
                    panOnlyWhenZoomed: true,
                    contain : "outside",
             
    
                });
    
                const zoomInButton = document.getElementById('zoomin'+index);
                const zoomOutButton = document.getElementById('zoomout'+index);
    
                    
                zoomInButton.addEventListener('click', () => {
    
                    panzoom.zoomIn()
                    $(element).css("cursor","move")
    
                } )
                zoomOutButton.addEventListener('click', () => {
        
                    panzoom.zoomOut()
                    setTimeout(() => {
    
                        $(element).css("transform","scale(1) translate(0px, 0px)")
                        $(element).css("cursor","default")
    
                    },20)
                } )
    
            })



        }

       

    }

    
    componentWillUnmount() {

        var script = document.querySelectorAll('script')

        script.forEach(ele => {

            if(ele.id === "ninja-slider" || ele.id === "thumbnail-slider"){
                ele.remove();
            }

        })


        
    }

    imageFullscreenView = (val) => {

        $(".full_screen_div").show()
        $("#fullscreen-view").attr('src',val);
    }
    imageFullscreenViewClos = () => {

        $(".full_screen_div").hide()
        $("#fullscreen-view").attr('src',"");

    }

    downloadimage = (fileUrl) => {


        axios.get(fileUrl, { responseType: 'blob'}).then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileUrl.substring(fileUrl.lastIndexOf('/')+1));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });

        // const fileName = 'myFile.png'

        // fetch(url)
        // .then(async response => {
        // const contentType = response.headers.get('content-type')
        // const blob = await response.blob()
        // const file = new File([blob], fileName, { contentType })
        // saveAs(file,'download.png');

        // // access file here
        // })

       
    }

    render() {

        let logoclass = ""
        let logoclassimg = { "height" : '90%' , "width" : 'auto' , 'objectFit' : 'cover','maxWidth' : '100%','left' : '0','right' : '0' , 'margin' : '0 auto'}
        if(this.props.info.ref === "prmedia_thermatru_product_logos" || this.props.info.ref === "prmedia_fypon_tools_btn5_logos"){
            logoclass = "logo_cls"
            logoclassimg =  { "height" : 'auto' , "width" : 'auto' , 'objectFit' : 'cover','maxWidth' : '65%','left' : '0','right' : '0' , 'margin' : '0 auto' , 'position' : 'relative', 'top' : '50%'}
        }

        return(

            <div className="gallery-slider-wrapper">

        
            <div id="ninja-slider" style={{ "float" : 'left'}}>
                <div className="slider-inner"  >
                    <ul>

                    {
                        this.props.imagesarr && this.props.imagesarr.map((val,index) => {
                            return (<li>
                                {/* <a className="ns-img" href={val}  id={`img${index}`}></a> */}
                                <div className={`panzoom ${logoclass}`}  id={`panzoom${index}`}>
                                
                                {
                                    (this.props.info.navigation_ref === "explore_the_trends" ) ? (
                                        <img src={val.img} 
                                        className="ns-img remove-background" id={`img${index}`} 
                                        style={{ "height" : '100%' , "width" : '100%' , 'objectFit' : 'contain'}}
                                        ></img>
                                    ) : (

                                        <img src={val.img} 
                                        className={`ns-img`} id={`img${index}`} 
                                        
                                        style={logoclassimg}
                                        ></img>
                                    )
                                }
                                    

                                </div>
                                <div className={`${this.props.info.navigation_ref === "explore_the_trends" ? '' : 'full_screen_icons'} `}>
                                    { (val.name !== "") && <div className="slider_contant"><p>{val.name}</p></div>} 
                                  

                                        {
                                            this.props.info.navigation_ref === "explore_the_trends" && (
                                                <div className="slider_bottom_icons text-right float-right plus-minus-bottom">

                                                    <button type="button" id={`zoomout${index}`}  className="btn btn-zoom zoom-out"> - </button>
                                                    <button type="button" id={`zoomin${index}`} className="btn btn-zoom" > + </button>
                                            </div>

                                            )
                                        }
                                            
                                    <div className="slider_bottom_icons text-right float-right">
                                        <a href="#">
                                            <img src="images/slider_fullscreen_icon.png" alt="" className="img-fluid img-gal" onClick={() => { this.imageFullscreenView(val.img) }} />
                                        </a>

                                            {
                                                (this.props.info.ref === "prmedia_thermatru_product_logos" || this.props.info.ref === "prmedia_fypon_tools_btn5_logos") ?

                                               ( 
                                                    <img src="images/download_btn.png" alt="" className="img-fluid img-gal ml-2 download_btn" onClick={() => { this.downloadimage(val.img) }}/>
                                                )

                                                : ''

                                             }
                              
                                    </div>
                                </div>
                            </li>)
                        })
                    }
                    
                    </ul>
                    <div className="fs-icon" title="Expand/Close"></div>
                </div>
            </div>
            <div id="thumbnail-slider" style={{ "float" : 'left'}}>
                <div className="inner">
                    <ul>
                            
                        {
                            this.props.imagesarr && this.props.imagesarr.map(val => {
                                return <li><a className="thumb" href={val.img} ></a></li>
                            })
                        }
                    
                      
                    </ul>
                </div>
            </div>

            <div></div>
        </div>

        )
    }
}